import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocusPayMerchantTitles } from "src/app/shared/models/enums/focuspay-merchant-contact-type";
import { MerchantContact } from "src/app/shared/models/FocusPay/FocusPayApplication.item";

@Component({
	selector: "app-application-merchant-contact",
	templateUrl: "./application-merchant-contact.component.html",
	styleUrls: ["../../focuspay.style.scss"],
})
export class ApplicationMerchantContactComponent implements OnInit {
	@Input() merchantContacts: MerchantContact[];
	@Input() readOnly: boolean;
	@Output() merchantContactsEmitter = new EventEmitter<MerchantContact[]>();
	@Output() inputActionEmitter = new EventEmitter<any>();
	@Output() displayModal = new EventEmitter<string>();
	@Output() sectionCompleteEmitter = new EventEmitter<any>();
	sectionStatus: Subject<any> = new Subject<any>();

	contactTitles: { label: string; value: string }[] = [];

	contactSectionState: {
		contactIndex: number;
		complete: boolean;
	}[] = [];

	recordError: string = undefined;

	sectionComplete: boolean = false;

	constructor(public app: AppService) {}

	ngOnInit(): void {
		for (const [k, v] of Object.entries(FocusPayMerchantTitles)) {
			this.contactTitles.push({
				label: k,
				value: v,
			});
		}

		this.merchantContacts.forEach((contact, idx) => {
			this.contactSectionState.push({
				contactIndex: idx,
				complete: false,
			});
		});
		setTimeout(() => {
			this.inputAction();
		}, 500);
	}

	ownerContactAdd() {
		this.merchantContacts.push(new MerchantContact());
		this.contactSectionState.push({
			contactIndex: this.merchantContacts.length - 1,
			complete: false,
		});
	}

	contactPocChange(contact: MerchantContact) {
		this.merchantContacts.forEach((c) => {
			if (c.firstName !== contact.firstName && c.lastName !== contact.lastName && c.isPoc) {
				c.isPoc = false;
			}
		}); // iterate through contacts, see if other contacts are POC, remove it not
	}

	inputAction(inputEvent?) {
		inputEvent && this.inputActionEmitter.emit(inputEvent);
		this.sectionComplete = false;
		this.sectionStatus.next({
			section: "owner",
			complete: false,
		});

		let totalOwnership: number = 0;
		for (let contact of this.merchantContacts) {
			totalOwnership += contact.ownershipPercentage;
		}
		if (totalOwnership > 100) {
			this.recordError = "More than 100% ownership cannot be provided. Please review the contacts ownership percentages";
			return;
		} else {
			this.recordError = undefined;
		}
		if (this.contactSectionState.some((contactSection) => !contactSection.complete)) return;

		this.sectionComplete = true;
		this.sectionStatus.next({
			section: "owner",
			complete: true,
		});
	}

	sectionChange(sectionChangeEvent) {
		const section = this.contactSectionState.find((i) => i.contactIndex === sectionChangeEvent.contactIndex);
		section.complete = sectionChangeEvent.complete;

		this.inputAction();
	}
}
